export default "__VITE_ASSET__5a07e9c3__"